module.exports = __webpack_public_path__ + "static/media/twitter.0b27013e.svg";